export default __webpack_public_path__ + "static/apyke-white-800-2f35149d2be080a396c629fa8941d4ca.png";